export default __webpack_public_path__ + "static/media/I-2022.216dd339.pdf";